import { array, object, string } from "yup";

import { EnabledLanguages } from "@framework/constants";
import { displayNameValidationSchema, emailValidationSchema, urlValidationSchema } from "@dzambalaorg/yup-rules";
import { UserRole, UserStatus } from "@framework/types";

export const userFormValidationSchema = object().shape({
  email: emailValidationSchema,
  displayName: displayNameValidationSchema,
  language: string().oneOf(Object.values(EnabledLanguages)).required("form.validations.valueMissing"),
  userRoles: array()
    .of(string().oneOf(Object.values(UserRole), "form.validations.typeMismatch"))
    .required("form.validations.valueMissing"),
  userStatus: string().oneOf(Object.values(UserStatus)).required("form.validations.valueMissing"),
  imageUrl: urlValidationSchema,
});
